export default __webpack_public_path__ + "img/apply-b3a43a23.png";